import { render } from "./SuperLig.vue?vue&type=template&id=031fa10e"
import script from "./SuperLig.vue?vue&type=script&lang=js"
export * from "./SuperLig.vue?vue&type=script&lang=js"

import "./SuperLig.vue?vue&type=style&index=0&id=031fa10e&lang=css"

import exportComponent from "C:\\Users\\HS\\Desktop\\fikstur\\my_fiksture\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__